export default "__VITE_ASSET__FsdgdyAW__"